// extracted by mini-css-extract-plugin
export default {"SButton":"SButton_SButton__s8Jrv","SButtonLight":"SButton_SButtonLight__gIy9t"};